<template>
  <div style="overflow-x: hidden;">
    <el-image class="round" :src="img" >
      <div slot="placeholder" class="image-slot">
        加载中<span class="dot">...</span>
      </div>
    </el-image>
    <h1 style="padding-left: 10px;">{{ msg }}</h1>
    <p style="padding-left: 10px;">{{abstract}}</p>
    <div v-html="detail.content"></div>
    <img class="head" v-if="!detail.content" src="../assets/illustration/产品详情-雪票详情/雪票.png" />
  </div>
</template>

<script>
import request from '../utils/request.js'
import Qs from 'qs' 
export default {
  name: 'hoteldetails',
  data () {
    return {
			msg: '云顶大酒店双人2住2滑 | 开板节平日',
			lang:1,
			ID:1,
			msg: '',
			abstract:'',
      img:'',
      detail: {}
    }
  },
	created(){
		this.ID=this.$route.query.combo_id;
		if(this.$route.query.lang){this.lang=this.$route.query.lang;}
		console.log('ID:'+this.ID+' lang:'+this.lang);
		this.$axios({
		  url: '/myyd/public/combo_detail',
		  method: 'post',
		  header: { 'content-type': 'application/x-www-form-urlencoded' },
		  data:Qs.stringify({
		    combo_id: this.ID,
		  	lang:this.lang
		  })
		// request({
		// 	url:"/myyd/public/combo_detail",
		// 	method:'post',
		// 	data:{
		// 		combo_id:this.ID,
		// 		lang:this.lang
		// 	}
		}).then(res => {
			console.log('请求结果：', res.data);
			let params=res.data.data;
			this.msg=params.title;
			this.abstract=params.abstract;
      this.img=params.img;
      this.detail = params
		});
	}
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.round {
    width:100%;
    height:100vw;
    border-radius: 0  0 0 50px ;
}
.head {
   width :100% ;
  
}
#yuyueguize {
    border: 1px solid #7E7E7E;
    opacity: 1;
    border-radius: 10px;    
    padding: 0 0px;
    width: 60px;
    height: 14px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 14px;
    color: #646464;
    text-align:center;
}
#buketui {
    border: 1px solid #FE0000;
    opacity: 1;
    border-radius: 10px;    
    width: 55px;
    height: 14px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 14px;
    color: #FE0000;
    text-align:center;
}
.td1 {
  padding-right: 15px;
}

h1 {
  width: 100%;
  
  text-align: justify;
  padding-left: 0px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 600; 
  line-height: 30px;
  color: #000000;
  opacity: 1;

}
h2 {
    width: 100%;
    height: 23px;
    text-align: justify;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 600;
    line-height: 15px;
    color: #1F1F1F;
    opacity: 1;
}
.table1 {
    text-align: justify;
    vertical-align:top;
    width:100%;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #000000;
    opacity: 1;
    
}

table tr td:first-child{
    width: 72px;
    height: 17px;
    vertical-align:top;
    
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #000000;
    opacity: 1;
}
table tr td:first-child +td {
  padding-right: 15px;
}

hr {  
    height: 0px;
    border: 1px solid #DDDDDD;
    opacity: 1;
}
.text {  
    width: 100%;
    text-align: justify;
    height: 17px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #000000;
    opacity: 0.5;    

}


.div2 {
  margin-top: 1em;
  vertical-align: top;
}

</style>



// WEBPACK FOOTER //
// src/components/PackageDetails.vue